// Xpertify brand mark — two chevron-style halves forming an X.
// Drop-in <XpertifyLogo /> for places that need the inline SVG (so it
// can inherit color via the `color` prop or stay brand orange by default).

import React from 'react';

interface Props {
  size?: number;
  /** Override the orange brand fill. Pass "currentColor" to inherit. */
  color?: string;
  className?: string;
}

const XpertifyLogo: React.FC<Props> = ({ size = 32, color = '#FF6600', className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 3840 3840"
    width={size}
    height={size}
    className={className}
    aria-label="Xpertify"
  >
    <g transform="translate(1920, 1920)" fill={color}>
      <path d="M -110,-550 L -660,-1100 L -1100,-660 L -550,-110 L -550,110 L -1100,660 L -660,1100 L -110,550 L -110,-550 Z" />
      <path d="M 110,-550 L 660,-1100 L 1100,-660 L 550,-110 L 550,110 L 1100,660 L 660,1100 L 110,550 L 110,-550 Z" />
    </g>
  </svg>
);

export default XpertifyLogo;
